<div class="row col-12 p-0 m-0 main-page-section">
    <div class="col-12 p-0 companies-section">
        <!-- <app-header></app-header> -->
        <div class="col-height">

            <div>
                <div class="breadcrumbs-section padding-left">
                    <span class="prev-page pt-1 "><a routerLink="/overview">Home</a></span>
                    <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
                    <span class="prev-page pt-1 "><a routerLink="/add-gst">GST</a></span>
                    <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
                </div>
            </div>

            <form class="add-bulletin-layout" [formGroup]="gstForm">
                <div class="row" style="margin-bottom: 20px;">
                    <div class="col-10">
                        <h1>GST</h1>
                    </div>
                    <div class="col-2" *ngIf="gstAdd">
                        <button type="button" (click)="onSubmit()">Add</button>
                    </div>
                </div>
                <div class="row" style="margin-bottom: 50px;">
                    <div class="col-lg-4">
                        <!-- IGST content goes here -->
                        <div class="row">
                            <div class="col-12">
                                <div class="text" style="margin-bottom: 10px;">
                                    IGST (%)
                                </div>
                            </div>
                            <div class="col-12">
                                <textarea type="text" name="igst" (keypress)="keyPressNumbersDecimal($event)"
                                    (input)="gstRange($event,1)" class="input-content" formControlName="igst"
                                    rows="1"></textarea>
                                <div class="field-error" *ngIf="f.igst.invalid && (f.igst.dirty || f.igst.touched)">
                                    <div *ngIf="f.igst.errors.required">IGST in % is required</div>
                                    <div *ngIf="f.igst.errors.pattern">Valid IGST percent is required</div>
                                </div>
                                <div *ngIf="showError1" class="field-error">
                                    Please enter a percentage value between 0 and 100
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <!-- CGST content goes here -->
                        <div class="row">
                            <div class="col-12">
                                <div class="text" style="margin-bottom: 10px;">
                                    CGST (%)
                                </div>
                            </div>
                            <div class="col-12">
                                <textarea type="text" name="cgst" (keypress)="keyPressNumbersDecimal($event)"
                                    (input)="gstRange($event,2)" class="input-content" formControlName="cgst"
                                    rows="1"></textarea>
                                <div class="field-error" *ngIf="f.cgst.invalid && (f.cgst.dirty || f.cgst.touched)">
                                    <div *ngIf="f.cgst.errors.required">CGST in % is required</div>
                                    <div *ngIf="f.cgst.errors.pattern">Valid CGST percent is required</div>
                                </div>
                                <div *ngIf="showError2" class="field-error">
                                    Please enter a percentage value between 0 and 100
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <!-- Empty space (half screen) -->
                    </div>
                </div>

                <div class="row" style="margin-bottom: 50px;">
                    <div class="col-lg-4">
                        <!-- SGST content goes here -->
                        <div class="row">
                            <div class="col-12">
                                <div class="text" style="margin-bottom: 10px;">
                                    SGST (%)
                                </div>
                            </div>
                            <div class="col-12">
                                <textarea type="text" name="sgst" (keypress)="keyPressNumbersDecimal($event)"
                                    (input)="gstRange($event,3)" class="input-content" formControlName="sgst"
                                    rows="1"></textarea>
                                <div class="field-error" *ngIf="f.sgst.invalid && (f.sgst.dirty || f.sgst.touched)">
                                    <div *ngIf="f.sgst.errors.required">SGST in % is required</div>
                                    <div *ngIf="f.sgst.errors.pattern">Valid SGST percent is required</div>
                                </div>
                                <div *ngIf="showError3" class="field-error">
                                    Please enter a percentage value between 0 and 100
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <!-- Convenience Fee content goes here -->
                        <!-- <div class="row">
                            <div class="col-12">
                                <div class="text" style="margin-bottom: 10px;">
                                    Convenience Fee (%)
                                </div>
                            </div>
                            <div class="col-12">
                                <textarea type="text" name="conFee" (keypress)="keyPressNumbersDecimal($event)"
                                    (input)="gstRange($event,4)" class="input-content" formControlName="conFee"
                                    rows="1"></textarea>
                                <div class="field-error" *ngIf="f.conFee.invalid && (f.conFee.dirty || f.conFee.touched)">
                                    <div *ngIf="f.conFee.errors.required">Convenience Fee in % is required</div>
                                    <div *ngIf="f.conFee.errors.pattern">Valid Convenience Fee percent is required</div>
                                </div>
                                <div *ngIf="showError4" class="field-error">
                                    Please enter a percentage value between 0 and 100
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="col-lg-4">
                        <!-- Empty space (half screen) -->
                    </div>
                </div>
            </form>

        </div>